import React, { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ROLES } from '../config/constants';

function ProtectedRoute({ children, requireAdmin = false, requireSuperAdmin = false }) {
	const { currentUser, loading, isInitialized } = useAuth();
	const [checking, setChecking] = useState(false);
	const location = useLocation();
	
	if (!isInitialized || loading || checking) return <div>Loading...</div>;
	if (!currentUser) {
		return <Navigate to="/sign-in" replace />;
	}

	// Email verification check
	if (!currentUser.emailVerified && !location.pathname.includes('/sign-in')) {
		// Redirect to sign-in page with a query parameter
		return <Navigate to="/sign-in?needsVerification=true" replace />;
	}

	// Only check for admin roles if they are required
	if (requireAdmin || requireSuperAdmin) {
		let authorized = true;

		if (requireSuperAdmin && currentUser.role !== ROLES.SUPER_ADMIN) {
			authorized = false;
		}

		if (requireAdmin && currentUser.role !== ROLES.ADMIN && currentUser.role !== ROLES.SUPER_ADMIN) {
			authorized = false;
		}

		if (!authorized) {
			return <Navigate to="/" replace />;
		}
	}

	return children;
}

export default ProtectedRoute;
